import { getJobIdsByExecuteId, getParams } from '../reducers/analyticsApp';
import handleResponse from './common';

export const fetchJsonByUrlEncodedPost = (
  path,
  body,
  { backendUrl, accessToken, tokenType, tenantId }
) =>
  fetch(`${backendUrl}${path}`, {
    method: 'POST',
    headers: {
      tenantId,
      Accept: 'application/json',
      'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      Authorization: `${tokenType} ${accessToken}`,
    },
    credentials: 'include',
    body,
  })
    .then(handleResponse)
    .then((response) => response.json());

export const fetchJsonByPost = (path, body, { backendUrl, accessToken, tokenType, tenantId }) =>
  fetch(`${backendUrl}${path}`, {
    method: 'POST',
    headers: {
      tenantId,
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `${tokenType} ${accessToken}`,
    },
    credentials: 'include',
    body: JSON.stringify(body),
  })
    .then(handleResponse)
    .then((response) => response.json());

export const fetchJsonByPut = (path, body, { backendUrl, accessToken, tokenType, tenantId }) =>
  fetch(`${backendUrl}${path}`, {
    method: 'PUT',
    headers: {
      tenantId,
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `${tokenType} ${accessToken}`,
    },
    credentials: 'include',
    body: JSON.stringify(body),
  })
    .then(handleResponse)
    .then((response) => response.json());

export const fetchTextByPost = (path, body, { backendUrl, accessToken, tokenType, tenantId }) =>
  fetch(`${backendUrl}${path}`, {
    method: 'POST',
    headers: {
      tenantId,
      Accept: 'text/plain',
      'Content-Type': 'application/json',
      Authorization: `${tokenType} ${accessToken}`,
    },
    credentials: 'include',
    body: JSON.stringify(body),
  })
    .then(handleResponse)
    .then((response) => response.text());

export const fetchJsonByGet = (path, { backendUrl, accessToken, tokenType, tenantId }) =>
  fetch(`${backendUrl}${path}`, {
    method: 'GET',
    headers: {
      tenantId,
      Accept: 'application/json',
      Authorization: `${tokenType} ${accessToken}`,
    },
    credentials: 'include',
  })
    .then(handleResponse)
    .then((response) => response.json());

export const fetchJsonByDelete = (path, { backendUrl, accessToken, tokenType, tenantId }) =>
  fetch(`${backendUrl}${path}`, {
    method: 'DELETE',
    headers: {
      tenantId,
      Accept: 'application/json',
      Authorization: `${tokenType} ${accessToken}`,
    },
    credentials: 'include',
  })
    .then(handleResponse)
    .then((response) => response.json());

export const noResponseDelete = (path, { backendUrl, accessToken, tokenType, tenantId }) =>
  fetch(`${backendUrl}${path}`, {
    method: 'DELETE',
    headers: {
      tenantId,
      Authorization: `${tokenType} ${accessToken}`,
    },
    credentials: 'include',
  }).then(handleResponse);

export const noResponseYamlPut = (path, body, { backendUrl, accessToken, tokenType, tenantId }) =>
  fetch(`${backendUrl}${path}`, {
    method: 'PUT',
    headers: {
      tenantId,
      'Content-Type': 'application/x-yaml',
      Authorization: `${tokenType} ${accessToken}`,
    },
    credentials: 'include',
    body,
  }).then(handleResponse);

export const fetchYamlByGet = (path, { backendUrl, accessToken, tokenType, tenantId }) =>
  fetch(`${backendUrl}${path}`, {
    method: 'GET',
    headers: {
      tenantId,
      Accept: 'application/x-yaml',
      Authorization: `${tokenType} ${accessToken}`,
    },
    credentials: 'include',
  })
    .then(handleResponse)
    .then((response) => response.text());

const runEventQuery = (query, { backendUrl, accessToken, tokenType, tenantId }) =>
  fetchJsonByPost('/events/query', query, { backendUrl, accessToken, tokenType, tenantId });

const runExposeEvent = (query, { backendUrl, accessToken, tokenType, tenantId }) =>
  fetchTextByPost(`/events/query/expose`, query, {
    backendUrl,
    accessToken,
    tokenType,
    tenantId,
  });

const executeJob = (jobId, { backendUrl, accessToken, tokenType, tenantId }) =>
  fetchJsonByGet(`/query?id=${jobId}`, { backendUrl, accessToken, tokenType, tenantId });

const cancelJob = (jobId, { backendUrl, accessToken, tokenType, tenantId }) =>
  // квери параметр для фикса TOOLS-3930, чтобы отличался эндпоинт для GET и DELETE запросов. Баг не воспроизводится для
  // Chrome в системе Arch Linux, но пока воспроизводится в Chrome/Windows и Chromium/Arch. Возможно с будущим обновлением пофиксится
  noResponseDelete(`/query?id=${jobId}&cancel=true`, {
    backendUrl,
    accessToken,
    tokenType,
    tenantId,
  });

const dispatchQueryIds = (executeId, ids, dispatch) => {
  dispatch({
    type: `SET_QUERY_IDS`,
    executeId,
    ids,
  });
};

export const dispatchRequestInfo = (executeId, dispatch, type, events, isCSV) => {
  dispatch({
    type: `SET_REQUEST_INFO`,
    executeId,
    appType: type,
    events,
    isCSV,
  });
};

const deleteRequestId = (executeId, dispatch) => {
  dispatch({
    type: `DELETE_QUERY_IDS`,
    executeId,
  });
};

const dispatchQueryId = (executeId, id, dispatch) => dispatchQueryIds(executeId, [id], dispatch);

export const executeTwoStepQueries = (apiFn, queries, executeId, dispatch, getState) => {
  const params = getParams(getState());
  return Promise.all(queries.map((query) => apiFn(query, params))).then((response) => {
    const ids = response.map(({ jobId }) => jobId);
    dispatchQueryIds(executeId, ids, dispatch);
    return Promise.all(ids.map((id) => executeJob(id, params))).finally(() =>
      deleteRequestId(executeId, dispatch)
    );
  });
};

export const executeTwoStepQuery = (apiFn, query, executeId, dispatch, getState) => {
  const params = getParams(getState());
  return apiFn(query, params).then(({ jobId }) => {
    dispatchQueryId(executeId, jobId, dispatch);
    return executeJob(jobId, params).finally(() => deleteRequestId(executeId, dispatch));
  });
};

export const cancelRequest = (executeId) => (dispatch, getState) => {
  const state = getState();
  const params = getParams(state);
  const ids = getJobIdsByExecuteId(state, executeId);
  return Promise.all(ids.map((id) => cancelJob(id, params)));
};

export const executeQuery = (apiFn, query, executeId, dispatch, getState) =>
  apiFn(query, getParams(getState()));

export const executeTwoStepEventQueries = (queries, executeId, dispatch, getState) =>
  executeTwoStepQueries(runEventQuery, queries, executeId, dispatch, getState);

export const executeTwoStepEventQuery = (query, executeId, dispatch, getState) =>
  executeTwoStepQuery(runEventQuery, query, executeId, dispatch, getState);

export const exposeEvent = (query, executeId, dispatch, getState) =>
  executeQuery(runExposeEvent, query, executeId, dispatch, getState);
